/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";

const announcement = (props) => {
  let announcementType = "";
  switch (props.type) {
    case "Critical":
      announcementType = "-critical";
      break;
    case "Warning":
      announcementType = "-warning";
      break;
    default:
      announcementType = "";
      break;
  }

  return (
    <a href="#" className="duyuru-link">
      <div onClick={props.onClick} className="duyuruPaddingArea">
        <div className="duyuruButton">
          <div className="duyuruTextArea">
            <div className="duyuruIcon">
              <span
                className={`iconmford fo-icon-speaker-notes${announcementType}`}
              ></span>
            </div>
            <div className="duyuruInfo">
              <div className="duyuruTarih">{props.announcementDate}</div>
              <div className="duyuruBaslik">{props.announcementTitle}</div>
            </div>
          </div>
          <div className="arrow">
            <span className="icon-icon-detail"></span>
          </div>
        </div>
      </div>
    </a>
  );
};

export default announcement;
